import Cookies from 'js-cookie'
// 认证信息包括 token && 需要在发请求时带在 header 上
const TOKEN_KEY = 'ADMIN_TOKEN'
// 登录后的用户信息
const USER_KEY = 'USER_INFO'
// const MAIN_URL = process.env.VUE_APP_MAIN_URL
const EXPIRES = 1 // 24 小时过期

export function getToken () {
  return Cookies.get(TOKEN_KEY)
}

export function setToken (value) {
  return Cookies.set(TOKEN_KEY, value, { expires: EXPIRES })
}

export function removeToken () {
  return Cookies.remove(TOKEN_KEY)
}

export function setUser (value) {
  return Cookies.set(USER_KEY, value, { expires: EXPIRES })
}

export function getUser () {
  return JSON.parse(Cookies.get(USER_KEY))
}

export function removeUser () {
  return Cookies.remove(USER_KEY)
}

export function hasPermission (params) {
  try {
    let roles = getUser().role_name
    roles = roles.split(',')
    return getToken() && roles.includes('校长')
  } catch (err) {
    console.log(err)
  }
}

export default {
  getToken,
  setToken,
  setUser,
  getUser,
  removeToken,
  removeUser
}
